export default __webpack_public_path__ + "static/media/eurostars.4abe5b46.png";